import { render, staticRenderFns } from "./InactivationsUnResolvedList.vue?vue&type=template&id=86d2adaa&"
import script from "./InactivationsUnResolvedList.vue?vue&type=script&lang=js&"
export * from "./InactivationsUnResolvedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports